var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.2 45",
    style: {
      enableBackground: "new 0 0 43.2 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.1,0h-35C0.5,0-1.4,4.3,1.2,6.9l6.6,7.5h27.7L42,6.9C44.5,4.3,42.7,0,39.1,0L39.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,18H10.9l8.9,10.1v13.3h-8.4c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h20.4c1,0,1.8-0.8,1.8-1.8 s-0.8-1.8-1.8-1.8h-8.4V28.1L32.3,18L32.3,18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.6527c860122161116ef0baba4757a28c.svg";
export { ForwardRef as ReactComponent };